import { IAplosApiRequestArgs } from "@/services/aplosApi";
import { QueueDataCleaningArgs } from "./QueueDataCleaningArgs";
import { QueueNCAAnalysisArgs } from "./QueueNCAAnalysisArgs";
import { QueueCustomCalculationsArgs } from "./QueueCustomCalculationsArgs";
import { QueuePlotsArgs } from "./QueuePlotsArgs";
import { QueueTablesArgs } from "./QueueTablesArgs";
import { QueueCustomReportsArgs } from "./QueueCustomReportsArgs";

export interface QueueExecutionArgsOptions {
    tenantId: string;
    userId: string;
    dataCleaningArgs?: QueueDataCleaningArgs;
    ncaAnalysisArgs?: QueueNCAAnalysisArgs;
    customCalculationsArgs?: QueueCustomCalculationsArgs;
    plotArgs?: QueuePlotsArgs;
    tableArgs?: QueueTablesArgs;
    customReportArgs?: QueueCustomReportsArgs;
}

export class QueueExecutionArgs implements IAplosApiRequestArgs {

    // For advanced analyses 
    public name?: string;
    public anyalsisFileId?: string;

    public tenantId: string;
    public userId: string;
    public dataCleaningArgs?: QueueDataCleaningArgs;
    public ncaAnalysisArgs?: QueueNCAAnalysisArgs;
    public customCalculationsArgs?: QueueCustomCalculationsArgs;
    public plotArgs?: QueuePlotsArgs;
    public tableArgs?: QueueTablesArgs;
    public customReportArgs?: QueueCustomReportsArgs;

    constructor(options: QueueExecutionArgsOptions) {

        if (options.tenantId == null) throw Error("valid tenantId is required");
        if (options.userId == null) throw Error("valid userId is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.dataCleaningArgs = options.dataCleaningArgs;
        this.ncaAnalysisArgs = options.ncaAnalysisArgs;
        this.customCalculationsArgs = options.customCalculationsArgs;
        this.plotArgs = options.plotArgs;
        this.tableArgs = options.tableArgs;
        this.customReportArgs = options.customReportArgs;
    }

}
